import './card.scss';

/**
 * version    1.0
 * class      <type> (Card)
 * classdesc
 */
export class Card {}
